var map = {
	"./fdb-ill1.jpg": 4208,
	"./fdb-ill2.jpg": 3635,
	"./fdb-ill3.jpg": 9567,
	"./fdb-main.jpg": 1812,
	"./fdb.jpg": 1363,
	"./fdb_slider.jpg": 3082,
	"./naturo-ill1.jpg": 185,
	"./naturo-ill2.jpg": 4824,
	"./naturo-ill3.jpg": 4333,
	"./naturo-main.jpg": 7966,
	"./naturo_slider.jpg": 5863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1267;